import React from "react";
import V4Paper, { PaperProps } from "@material-ui/core/Paper";

interface PaperWrapperProps extends PaperProps {
    zDepth?: number;
}

/**
 * Paper wrapper that supports both V0 and V4 APIs
 * Maps V0 zDepth prop to V4 elevation prop
 */
export const Paper: React.FC<PaperWrapperProps> = ({ zDepth, elevation, ...props }) => {
    // Map V0 zDepth to V4 elevation
    const paperElevation = elevation ?? zDepth;

    return <V4Paper {...props} elevation={paperElevation} />;
};
